import { Box, Flex, Text } from '@chakra-ui/react';

import { StopWatchIcon } from '~/features/experiments/ab_plp_redesign_2025/icons';

const ENDS_SOON_EYEBROW_LABEL = 'Ends soon';

export type EndsSoonEyebrowVariant = 'july_4th' | 'labor_day' | 'mid_year_sale' | 'summer';
export type EndsSoonEyebrowSize = 'default' | 'compact';

const PALETTE: Record<EndsSoonEyebrowVariant, { color: string; ruleColor: string }> = {
  summer: { color: '#EE7622', ruleColor: '#EE7622' },
  mid_year_sale: { color: '#EE7622', ruleColor: '#EE7622' },
  july_4th: { color: '#E5A5FF', ruleColor: 'rgba(229, 165, 255, 0.6)' },
  labor_day: { color: '#E5A5FF', ruleColor: 'rgba(229, 165, 255, 0.6)' },
};

/**
 * Shared "ENDS SOON" eyebrow row: optional stopwatch icon + uppercase condensed label + thin divider.
 * `summer` uses orange `#EE7622` on white surfaces; `july_4th`/`labor_day` use purple `#E5A5FF` on
 * dark promo cards.
 */
export function EndsSoonEyebrow({
  size = 'default',
  variant = 'summer',
}: {
  size?: EndsSoonEyebrowSize;
  variant?: EndsSoonEyebrowVariant;
}) {
  const { color, ruleColor } = PALETTE[variant];
  const isCompact = size === 'compact';

  return (
    <Flex alignItems='center' gap={isCompact ? 2 : 4} width='100%'>
      <Flex alignItems='center' color={color} flexShrink={0} gap={2}>
        {!isCompact ? <StopWatchIcon height='16px' width='16px' /> : null}
        <Text
          fontFamily='condensed'
          fontSize={isCompact ? '12px' : '0.9375rem'}
          fontWeight='500'
          letterSpacing={isCompact ? '0.1em' : '0.06em'}
          lineHeight={1}
          textTransform='uppercase'
          whiteSpace='nowrap'
        >
          {ENDS_SOON_EYEBROW_LABEL}
        </Text>
      </Flex>
      <Box
        backgroundColor={ruleColor}
        flex={1}
        height='1px'
        minWidth={0}
        opacity={variant === 'summer' || variant === 'mid_year_sale' ? 1 : 0.6}
      />
    </Flex>
  );
}
